import { parseItems } from './parsers/items';
import { toError } from './parsers/error';
export function initItems(settings, http) {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      album_id: folderId || null,
      maxResults: options.paging.size || settings.itemsLimit,
      pageToken: options.paging.cursor || ''
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/files`, requestOptions, {
      withCredentials: true
    }).then(parseItems).catch(toError);
  }
  return {
    list
  };
}